import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const InsightCardStyle = styled('div')`
  ${media.mobile} {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
  ${media.desktop} {
    min-height: 274px;
    margin-bottom: 40px;
    background-color: #ffffff;
  }
  .insightcard {
    &-desc-wrap {
      ${media.mobile} {
        flex: none;
        max-width: calc(100% - 159px);
      }
      ${media.desktop} {
        padding-left: 8px;
        margin-top: 8px;
      }
    }
    &--title {
      font-family: 'Pretendard-Bold';
      font-size: 15px;
      color: #333333;
      line-height: 20px;
      word-break: keep-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      ${media.mobile} {
        height: 40px;
      }
      ${media.desktop} {
        height: 44px;
        font-size: 18px;
        line-height: 22px;
      }
    }
    &--tags {
      display: flex;
      flex-wrap: wrap;
      margin-top: 8px;
    }
    &--tag {
      color: #999999;
      font-size: 11px;
      margin-right: 12px;
      flex: none;
      max-width: 100%;
      ${media.desktop} {
        font-size: 12px;
      }
    }
    &--image {
      background-image: url(${(props: { image: string }) => (props.image ? props.image : '')});
      background-size: cover;
      background-repeat: no-repeat;
      width: 120px;
      height: 72px;
      ${media.desktop} {
        width: 304px;
        height: 181px;
      }
    }
  }
`;

export default InsightCardStyle;
